export default {
  workstation: {
    tabs: {
      workstation: "Poste de travail",
    },
    filters: {
      withAll: "Avec tous",
      withoutAny: "Sans aucun",
      withPlayer: "Avec {{player}}",
      withoutPlayer: "Sans {{player}}",
      all: "Tous",
      versusPosition: "c. {{position}}",
      starter: "Partant",
      nonStarter: "Non-partant",
      starterAndNonStarter: "Partant + non-partant",
      betType: "Type de pari",
      timeframe: "Période",
      splits: "Répartition",
      with: "Avec",
      without: "Sans",
      opponent: "Adversaire",
    },
    actions: {
      applyFilter: "Appliquer le filtre",
      applied: "Appliqué",
    },
    banners: {
      notPlayingToday: "{{entity}} ne joue pas aujourd'hui",
    },
    sections: {
      stats: "Stats",
      seasonStats: "Stats de saison",
      last3Seasons: "3 dernières saisons",
      batterVsPitcherGamelog: "Voir le journal frappeur c. lanceur",
    },
    stats: {
      perGame: "Par match",
      total: "Total",
      timeframe: "Période",
      filters: "Filtres",
      season: "Saison",
    },
    headers: {
      type: "Type",
      hitRate: "Taux de réussite",
      odds: "Cotes",
      stat: "Stat",
      average: "Moyenne",
    },
    outcomes: {
      covered: "Couvert",
      yes: "Oui",
      no: "Non",
      win: "V",
      loss: "D",
      tie: "NUL",
    },
    alerts: {
      imageSavedToDevice: "Image enregistrée sur l'appareil",
    },
  },
};
